module.exports = __webpack_public_path__ + "src/assets/img/illustrations/person-working-under-calendar.f40dfc74ba66e116adaf5adc90dfbe1f.png";